var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"animated fadeIn"},[_c('div',{staticClass:"app-default-heading clearfix"},[_c('h1',{staticClass:"d-inline-block display-4 text-left"},[(_vm.text)?_c('span',[_vm._v(_vm._s(this.text))]):_vm._t("default")],2),_c('div',{staticClass:"d-inline-block float-right"},[_vm._t("right")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }